import { Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHref } from 'react-router-dom';

export const BacktoHomeErrorMessage = () => {
  const { t } = useTranslation();
  const basename = useHref('/');
  const reloadPage = () => window.location.replace(basename);

  return (
    <Grid container flexDirection="column" justifyContent="center" alignItems="center" padding="40px" gap="40px">
      <Grid item>
        <Typography variant="h1">{t('errorBoundary.title')}</Typography>
      </Grid>
      <Grid item display="flex" flexDirection="column" alignItems="center" gap="40px">
        <Typography variant="p16">{t('errorBoundary.message')}</Typography>
        <Button variant="contained" color="secondary" onClick={reloadPage}>
          {t('button.backHome')}
        </Button>
      </Grid>
    </Grid>
  );
};
